// extracted by mini-css-extract-plugin
module.exports = {"SC_container":"SingleCityComponent-module__SC_container"};